"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Tag = _interopRequireDefault(require("@rsuite/icon-font/lib/application/Tag"));

// Generated by script, don't edit it please.
var Tag = (0, _createSvgIcon["default"])({
  as: _Tag["default"],
  ariaLabel: 'tag',
  category: 'application',
  displayName: 'Tag'
});
var _default = Tag;
exports["default"] = _default;
module.exports = exports.default;